import React from 'react';
import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  viewAllHref?: string;
  accentColor?: 'cyan' | 'purple';
}

export default function SectionHeader({
  title,
  subtitle,
  viewAllHref,
  accentColor = 'cyan',
}: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between mb-6">
      <div>
        <h2 className={`text-xl sm:text-2xl font-bold ${accentColor === 'cyan' ? 'text-gradient-cyan' : 'text-gradient-purple'}`}>
          {title}
        </h2>
        {subtitle && <p className="text-sm text-muted-foreground mt-0.5 font-body">{subtitle}</p>}
      </div>
      {viewAllHref && (
        <Link
          href={viewAllHref}
          className="flex items-center gap-1 text-sm font-semibold text-primary hover:text-foreground transition-colors duration-200"
        >
          View All
          <ChevronRight size={16} />
        </Link>
      )}
    </div>
  );
}